// High-quality world map coordinates based on Natural Earth data
// Each continent has detailed outline coordinates for smooth curves

export const CONTINENT_COORDS = {
  // NORTH AMERICA - Detailed coastline
  northAmerica: [
    [71.4, -156.8], [70.3, -148.5], [69.1, -142.0], [68.5, -136.2], [67.8, -140.5],
    [66.2, -162.3], [64.5, -165.4], [62.8, -166.2], [60.5, -165.8], [58.2, -157.0],
    [56.8, -154.2], [55.5, -159.5], [54.2, -164.8], [52.5, -169.5], [51.0, -178.5],
    [54.5, -130.5], [53.2, -132.8], [52.0, -131.2], [50.8, -128.5], [49.5, -126.8],
    [48.5, -124.8], [47.2, -124.2], [46.8, -124.0], [45.5, -124.0], [43.8, -124.2],
    [42.0, -124.5], [40.5, -124.4], [38.5, -123.2], [37.5, -122.5], [36.5, -122.0],
    [35.2, -120.8], [34.5, -120.5], [33.8, -118.5], [32.8, -117.2], [31.5, -116.8],
    [30.2, -116.0], [28.5, -114.2], [27.0, -112.5], [25.5, -110.8], [24.0, -110.2],
    [23.2, -109.8], [22.5, -106.5], [21.5, -105.2], [20.5, -105.5], [19.2, -105.0],
    [18.0, -103.5], [17.5, -101.8], [16.8, -99.5], [15.8, -96.2], [15.2, -93.5],
    [16.5, -92.5], [17.8, -91.5], [18.5, -91.2], [19.8, -90.5], [21.2, -90.2],
    [21.5, -88.2], [21.8, -87.0], [20.5, -87.5], [19.0, -87.8], [18.5, -88.5],
    [17.2, -88.2], [16.0, -88.8], [15.5, -89.2], [14.5, -90.5], [13.8, -89.8],
    [13.2, -88.5], [12.5, -87.2], [11.8, -85.8], [11.0, -84.0], [10.2, -83.5],
    [9.5, -82.8], [9.0, -81.5], [8.5, -80.0], [8.0, -78.5], [7.5, -77.5],
    [29.8, -84.0], [30.2, -85.5], [30.5, -87.8], [30.2, -89.5], [29.5, -90.0],
    [29.0, -92.5], [28.5, -94.0], [28.0, -96.5], [27.2, -97.5], [26.0, -97.2],
    [25.5, -97.0], [25.2, -80.5], [26.5, -80.0], [27.8, -80.2], [29.0, -80.8],
    [30.5, -81.2], [31.8, -80.8], [32.5, -79.8], [33.2, -79.2], [34.0, -78.0],
    [35.0, -76.5], [36.2, -75.8], [37.0, -76.0], [37.8, -75.5], [38.8, -75.0],
    [39.5, -74.2], [40.5, -74.0], [41.0, -72.5], [41.5, -71.0], [42.0, -70.5],
    [42.5, -70.8], [43.5, -70.2], [44.0, -69.0], [44.8, -67.0], [45.5, -64.5],
    [46.0, -60.5], [47.5, -59.5], [47.0, -56.0], [46.5, -53.5], [47.8, -52.8],
    [49.5, -55.5], [51.5, -56.0], [53.0, -56.5], [55.5, -60.0], [58.0, -62.5],
    [60.5, -64.5], [63.5, -68.5], [66.0, -70.5], [68.5, -72.8], [70.0, -80.5],
    [71.5, -85.0], [72.5, -95.0], [73.0, -105.0], [74.0, -115.0], [74.5, -125.0],
    [73.5, -135.0], [72.0, -140.0], [71.0, -148.0], [71.4, -156.8]
  ],

  // SOUTH AMERICA
  southAmerica: [
    [12.5, -72.0], [11.8, -71.5], [11.0, -74.5], [10.0, -75.5], [9.0, -77.0],
    [7.5, -77.8], [6.0, -77.5], [4.5, -77.8], [2.5, -78.8], [0.5, -80.0],
    [-1.0, -80.5], [-2.5, -81.0], [-4.0, -81.2], [-5.5, -80.8], [-7.0, -79.5],
    [-8.5, -78.5], [-10.0, -78.0], [-12.0, -77.0], [-14.0, -76.5], [-16.0, -75.0],
    [-18.0, -72.5], [-20.0, -70.5], [-22.5, -70.2], [-24.0, -70.5], [-26.0, -71.0],
    [-28.0, -71.5], [-30.0, -72.0], [-32.0, -71.5], [-34.0, -72.0], [-36.0, -73.5],
    [-38.0, -74.0], [-40.0, -74.5], [-42.5, -75.0], [-44.5, -74.0], [-46.0, -75.5],
    [-48.0, -74.5], [-50.0, -75.0], [-52.0, -72.5], [-54.0, -70.5], [-55.5, -68.0],
    [-54.5, -65.0], [-53.0, -68.5], [-51.5, -69.5], [-50.0, -68.0], [-48.5, -66.0],
    [-46.5, -67.5], [-44.5, -65.5], [-42.5, -64.5], [-40.5, -62.5], [-38.5, -58.5],
    [-36.5, -56.5], [-35.0, -54.0], [-33.5, -52.0], [-32.0, -52.5], [-30.5, -51.0],
    [-28.5, -49.0], [-26.5, -48.5], [-24.5, -46.5], [-23.0, -44.5], [-22.0, -41.5],
    [-20.0, -40.0], [-18.5, -39.0], [-16.0, -39.0], [-14.0, -38.8], [-12.0, -37.5],
    [-10.0, -36.5], [-8.0, -35.0], [-6.5, -35.0], [-5.0, -36.5], [-3.5, -40.0],
    [-2.0, -44.5], [-0.5, -48.0], [1.0, -50.5], [3.0, -52.0], [5.0, -54.5],
    [6.5, -58.0], [8.0, -60.5], [9.5, -62.5], [10.5, -65.0], [11.5, -68.5],
    [12.5, -72.0]
  ],

  // AFRICA
  africa: [
    [37.5, -9.0], [36.8, -6.5], [36.0, -3.0], [35.5, 0.0], [35.0, 2.5],
    [34.5, 5.0], [33.5, 8.0], [32.5, 10.5], [32.0, 13.0], [31.5, 16.0],
    [31.0, 20.0], [30.0, 24.0], [29.0, 28.0], [27.5, 31.0], [25.5, 33.0],
    [23.5, 35.5], [21.5, 37.0], [19.5, 38.5], [17.0, 40.0], [14.5, 42.0],
    [12.0, 44.0], [10.5, 45.5], [8.0, 47.5], [5.5, 49.0], [3.0, 50.5],
    [0.5, 49.0], [-2.0, 46.5], [-4.5, 43.0], [-7.0, 40.5], [-9.5, 39.0],
    [-11.5, 40.5], [-14.0, 41.0], [-16.5, 40.5], [-18.5, 38.0], [-20.5, 35.5],
    [-22.0, 35.0], [-24.0, 33.5], [-26.0, 31.0], [-28.0, 28.5], [-30.0, 26.0],
    [-32.0, 23.0], [-33.5, 20.0], [-34.5, 18.5], [-34.0, 17.0], [-33.0, 15.5],
    [-31.5, 16.5], [-29.5, 16.0], [-27.0, 15.0], [-25.0, 14.5], [-23.0, 14.5],
    [-21.0, 13.5], [-19.0, 12.0], [-17.0, 11.5], [-15.0, 12.0], [-13.0, 10.5],
    [-11.0, 9.0], [-9.5, 7.5], [-8.0, 5.5], [-7.0, 4.0], [-5.5, 5.5],
    [-4.5, 7.5], [-3.5, 8.5], [-2.0, 7.0], [-0.5, 6.0], [1.0, 5.5],
    [2.5, 6.5], [4.5, 5.0], [6.0, 2.5], [6.5, 0.5], [6.0, -3.0],
    [5.5, -6.5], [6.5, -9.5], [8.0, -12.0], [10.0, -14.5], [12.0, -16.0],
    [14.0, -17.0], [16.0, -16.5], [18.5, -16.0], [21.0, -17.5], [23.5, -17.0],
    [26.0, -15.5], [28.5, -13.0], [30.5, -10.5], [32.5, -8.0], [34.5, -5.5],
    [36.0, -4.0], [37.5, -9.0]
  ],

  // EUROPE
  europe: [
    [36.0, -9.5], [37.0, -8.5], [38.5, -9.0], [40.0, -9.0], [41.5, -9.0],
    [43.0, -9.5], [43.5, -8.0], [43.8, -5.5], [43.5, -2.0], [43.0, 0.0],
    [42.5, 3.0], [43.5, 4.0], [43.2, 6.5], [44.0, 8.0], [44.5, 9.5],
    [45.5, 10.0], [45.0, 12.5], [44.0, 12.5], [42.5, 14.0], [41.5, 15.5],
    [40.5, 17.5], [39.5, 18.5], [38.0, 16.0], [37.0, 15.5], [36.5, 14.5],
    [37.5, 12.5], [38.5, 12.5], [39.5, 16.0], [41.0, 17.0], [42.5, 17.5],
    [44.5, 14.0], [45.5, 14.0], [46.0, 16.0], [45.5, 17.0], [44.5, 18.5],
    [43.0, 17.5], [42.0, 19.0], [40.5, 20.0], [39.0, 20.5], [38.0, 22.0],
    [36.5, 23.0], [35.5, 24.0], [36.0, 26.0], [37.5, 24.0], [39.0, 24.0],
    [40.5, 26.0], [41.5, 28.0], [42.0, 28.5], [42.5, 28.0], [43.5, 28.5],
    [44.5, 30.0], [45.5, 30.0], [46.5, 31.0], [48.0, 28.0], [50.0, 26.0],
    [52.0, 24.0], [54.0, 22.0], [55.5, 21.0], [56.5, 18.0], [57.0, 15.0],
    [58.0, 12.0], [59.5, 10.5], [62.0, 10.0], [64.0, 10.5], [66.0, 12.5],
    [68.5, 15.0], [70.0, 20.0], [71.0, 25.0], [70.5, 28.0], [69.0, 30.0],
    [67.0, 27.0], [65.0, 24.5], [63.5, 22.0], [62.0, 18.0], [60.5, 20.5],
    [59.0, 22.5], [57.5, 24.5], [56.0, 27.0], [54.5, 23.5], [53.0, 21.0],
    [51.5, 19.0], [50.0, 16.5], [48.5, 15.5], [47.0, 14.0], [46.0, 15.0],
    [45.0, 14.0], [44.0, 12.5], [43.5, 10.0], [44.5, 8.5], [46.0, 7.5],
    [47.5, 7.0], [49.0, 5.5], [50.5, 4.0], [51.5, 3.5], [51.0, 1.5],
    [52.5, 1.0], [53.5, 0.0], [54.0, -3.0], [56.0, -5.0], [58.0, -6.5],
    [59.0, -3.0], [60.0, -1.0], [58.5, 0.0], [57.5, -2.0], [56.0, -5.0],
    [54.0, -6.0], [52.0, -5.5], [50.5, -4.5], [49.0, -5.0], [47.5, -4.0],
    [46.0, -2.0], [45.0, -1.0], [44.0, -1.5], [43.0, -1.5], [42.5, -3.0],
    [41.5, -4.0], [40.0, -4.5], [38.5, -5.5], [37.0, -6.5], [36.0, -9.5]
  ],

  // MIDDLE EAST & ARABIAN PENINSULA (onde fica Dubai!)
  middleEast: [
    [42.0, 26.0], [40.5, 28.0], [39.0, 30.0], [37.5, 32.0], [36.0, 34.0],
    [35.0, 36.0], [36.5, 38.0], [37.0, 40.0], [36.5, 42.0], [35.5, 44.0],
    [33.5, 44.5], [32.0, 46.0], [30.5, 48.0], [29.0, 48.5], [27.5, 50.0],
    [26.5, 51.5], [25.5, 52.0], [24.5, 54.0], [24.0, 56.0], [23.5, 58.0],
    [22.5, 59.5], [21.0, 59.0], [19.0, 58.0], [17.0, 55.0], [15.5, 52.5],
    [14.0, 48.5], [12.5, 45.0], [13.0, 43.5], [14.5, 42.5], [16.0, 43.0],
    [18.0, 42.0], [20.0, 40.5], [22.5, 39.0], [25.0, 37.5], [27.5, 35.5],
    [29.5, 34.5], [31.0, 35.0], [32.5, 35.5], [34.0, 36.0], [35.5, 35.5],
    [37.0, 36.5], [38.5, 35.0], [40.0, 32.0], [41.0, 29.0], [42.0, 26.0]
  ],

  // ASIA - Russia, China, India, Southeast Asia
  asia: [
    [77.0, 68.0], [78.0, 90.0], [77.5, 105.0], [76.0, 115.0], [74.5, 130.0],
    [72.0, 140.0], [70.0, 160.0], [68.0, 170.0], [65.0, 175.0], [63.0, 172.0],
    [60.5, 165.0], [58.0, 155.0], [55.5, 148.0], [53.0, 143.0], [51.0, 140.0],
    [48.0, 140.5], [46.0, 143.0], [44.5, 144.5], [43.0, 146.0], [42.0, 143.0],
    [40.0, 140.0], [38.0, 138.0], [36.0, 136.0], [34.0, 132.0], [33.0, 129.0],
    [35.0, 127.0], [38.0, 126.0], [40.0, 124.0], [41.0, 122.0], [40.5, 120.0],
    [38.0, 118.0], [35.0, 119.0], [32.0, 121.0], [30.0, 122.0], [28.0, 120.0],
    [25.0, 118.0], [23.0, 117.0], [21.0, 110.0], [18.0, 108.5], [16.0, 108.0],
    [13.0, 109.0], [10.0, 107.0], [8.0, 105.0], [6.0, 103.0], [4.0, 101.0],
    [2.0, 103.0], [0.0, 104.0], [-2.0, 106.0], [-4.0, 105.5], [-6.0, 107.0],
    [-7.5, 110.0], [-8.0, 114.0], [-8.5, 117.0], [-8.0, 120.0], [-6.5, 118.0],
    [-4.0, 116.0], [-2.0, 118.0], [0.0, 120.0], [2.0, 118.0], [4.0, 117.0],
    [6.0, 116.5], [8.0, 117.0], [10.0, 119.0], [12.0, 120.0], [14.0, 121.0],
    [16.0, 120.0], [18.0, 120.5], [20.0, 121.0], [22.0, 120.0], [23.5, 118.0],
    [22.0, 114.0], [21.0, 110.0], [20.5, 107.0], [18.0, 106.0], [16.0, 108.0],
    [14.0, 109.0], [12.0, 109.5], [10.0, 108.0], [8.0, 105.0], [6.0, 100.5],
    [8.0, 98.5], [10.0, 98.0], [12.0, 99.0], [14.0, 99.5], [16.0, 98.0],
    [18.0, 95.0], [20.0, 92.5], [22.0, 90.0], [24.0, 89.0], [26.0, 89.5],
    [28.0, 88.0], [27.5, 85.0], [26.0, 82.0], [24.0, 80.0], [22.0, 79.0],
    [20.0, 80.0], [18.0, 80.5], [15.0, 80.0], [12.0, 79.5], [10.0, 78.0],
    [8.5, 77.0], [8.0, 78.5], [9.5, 80.0], [11.0, 80.0], [13.0, 80.5],
    [15.0, 81.0], [17.0, 82.0], [19.0, 85.0], [21.0, 88.0], [23.0, 88.5],
    [24.0, 92.0], [22.5, 94.0], [20.0, 92.5], [18.0, 94.0], [16.0, 96.0],
    [14.0, 98.0], [12.0, 98.5], [10.0, 99.0], [8.0, 98.0], [6.0, 99.5],
    [4.0, 98.0], [6.0, 96.0], [8.0, 94.0], [10.0, 93.0], [12.0, 93.5],
    [14.0, 93.0], [16.0, 94.5], [18.0, 94.0], [20.0, 91.0], [22.0, 88.5],
    [24.0, 85.0], [26.0, 80.0], [28.0, 74.0], [30.0, 70.0], [32.0, 66.0],
    [34.0, 62.0], [36.0, 56.0], [38.0, 50.0], [40.0, 46.0], [42.0, 44.0],
    [44.0, 40.0], [46.0, 42.0], [48.0, 46.0], [50.0, 50.0], [52.0, 55.0],
    [54.0, 58.0], [56.0, 60.0], [58.0, 56.0], [60.0, 52.0], [62.0, 48.0],
    [64.0, 44.0], [66.0, 42.0], [68.0, 44.0], [70.0, 50.0], [72.0, 55.0],
    [74.0, 60.0], [76.0, 65.0], [77.0, 68.0]
  ],

  // INDIA subcontinent
  india: [
    [35.0, 74.0], [34.0, 76.0], [32.0, 78.0], [30.0, 80.0], [28.0, 84.0],
    [26.0, 88.0], [24.0, 90.0], [22.0, 92.0], [20.0, 93.0], [18.0, 94.0],
    [16.0, 96.0], [14.0, 98.0], [12.0, 98.0], [10.0, 98.5], [8.0, 98.0],
    [6.0, 99.0], [6.0, 96.0], [7.0, 94.0], [8.0, 93.0], [8.5, 77.0],
    [10.0, 78.0], [12.0, 80.0], [14.0, 80.0], [16.0, 82.0], [18.0, 84.0],
    [20.0, 86.0], [22.0, 88.0], [24.0, 88.5], [26.0, 86.0], [28.0, 84.0],
    [30.0, 80.0], [32.0, 76.0], [34.0, 74.0], [35.0, 74.0]
  ],

  // AUSTRALIA
  australia: [
    [-12.0, 130.0], [-12.5, 132.0], [-14.5, 129.0], [-15.5, 128.5], [-17.0, 123.5],
    [-19.0, 121.0], [-20.5, 118.5], [-22.0, 114.0], [-24.0, 113.5], [-26.0, 113.0],
    [-28.0, 114.0], [-30.0, 115.0], [-32.0, 116.0], [-34.0, 119.0], [-35.0, 123.0],
    [-35.5, 130.0], [-37.0, 140.0], [-38.5, 145.0], [-39.0, 147.0], [-38.0, 148.5],
    [-36.0, 150.0], [-34.0, 151.5], [-32.0, 153.0], [-30.0, 153.5], [-28.0, 153.5],
    [-26.0, 153.0], [-24.0, 152.0], [-22.0, 150.0], [-20.0, 148.5], [-18.0, 147.0],
    [-16.0, 145.5], [-14.0, 144.0], [-12.0, 142.0], [-10.5, 142.0], [-10.5, 140.0],
    [-12.5, 137.0], [-12.0, 135.0], [-12.0, 130.0]
  ],

  // GREENLAND
  greenland: [
    [60.0, -43.0], [62.0, -42.0], [64.0, -40.0], [66.0, -37.0], [68.0, -32.0],
    [70.0, -27.0], [72.0, -22.0], [74.0, -20.0], [76.0, -19.0], [78.0, -20.0],
    [80.0, -24.0], [81.5, -30.0], [83.0, -38.0], [83.5, -45.0], [82.0, -52.0],
    [80.0, -58.0], [78.0, -64.0], [76.0, -68.0], [74.0, -68.0], [72.0, -66.0],
    [70.0, -60.0], [68.0, -54.0], [66.0, -50.0], [64.0, -48.0], [62.0, -46.0],
    [60.0, -43.0]
  ],

  // UK & IRELAND
  ukIreland: [
    [50.0, -5.5], [50.5, -4.0], [51.0, -3.0], [51.5, -2.5], [51.0, 1.0],
    [52.0, 1.5], [53.0, 0.5], [54.0, -1.0], [55.0, -1.5], [56.0, -2.5],
    [57.0, -2.0], [58.0, -3.0], [58.5, -5.0], [57.5, -6.5], [56.5, -6.0],
    [55.5, -5.5], [54.5, -5.0], [53.5, -5.0], [53.0, -6.0], [54.0, -8.0],
    [55.0, -8.5], [55.5, -7.5], [54.5, -6.0], [53.5, -6.0], [52.5, -6.5],
    [52.0, -8.0], [51.5, -10.0], [51.5, -9.5], [52.0, -10.5], [53.5, -10.0],
    [54.5, -10.5], [55.0, -9.0], [54.0, -8.0], [53.0, -9.5], [52.0, -9.5],
    [51.5, -9.0], [51.0, -7.0], [50.0, -5.5]
  ],

  // JAPAN
  japan: [
    [31.0, 130.5], [32.0, 130.0], [33.5, 130.5], [34.0, 132.0], [34.5, 134.0],
    [35.0, 136.0], [36.0, 138.0], [37.0, 139.0], [38.0, 139.5], [39.0, 140.0],
    [40.0, 140.5], [41.0, 141.0], [42.0, 141.0], [43.0, 141.5], [44.0, 142.0],
    [45.0, 142.0], [45.5, 142.0], [44.0, 145.5], [43.0, 145.5], [42.0, 145.0],
    [41.0, 143.0], [40.0, 142.0], [39.0, 140.5], [38.0, 139.0], [37.0, 137.5],
    [36.0, 136.5], [35.0, 135.0], [34.0, 133.5], [33.0, 132.0], [32.0, 131.0],
    [31.0, 130.5]
  ],

  // NEW ZEALAND
  newZealand: [
    [-34.5, 173.0], [-35.5, 174.5], [-37.0, 175.5], [-38.5, 178.0], [-40.0, 177.0],
    [-41.5, 175.5], [-42.5, 173.0], [-44.0, 171.0], [-45.5, 167.0], [-46.5, 168.5],
    [-45.5, 170.5], [-44.5, 171.0], [-43.0, 173.5], [-41.5, 174.5], [-40.0, 175.5],
    [-38.5, 177.5], [-37.0, 175.0], [-35.5, 174.0], [-34.5, 173.0]
  ],

  // MADAGASCAR
  madagascar: [
    [-12.0, 49.5], [-13.5, 50.0], [-15.5, 50.5], [-18.0, 50.0], [-20.0, 48.5],
    [-22.0, 47.5], [-24.0, 47.0], [-25.5, 45.5], [-25.0, 44.0], [-23.5, 43.5],
    [-21.5, 43.5], [-19.0, 44.0], [-17.0, 44.5], [-15.0, 46.0], [-13.0, 48.0],
    [-12.0, 49.5]
  ],

  // INDONESIA main islands
  indonesia: [
    [-6.0, 105.0], [-7.0, 106.0], [-8.0, 108.0], [-8.5, 112.0], [-8.0, 115.0],
    [-8.5, 118.0], [-9.0, 122.0], [-8.5, 126.0], [-7.0, 128.0], [-5.0, 127.0],
    [-3.0, 128.0], [-1.5, 130.0], [0.0, 128.0], [1.5, 125.0], [3.0, 120.0],
    [4.0, 117.0], [5.0, 115.0], [4.5, 112.0], [2.5, 108.0], [1.0, 105.0],
    [-1.0, 104.0], [-3.0, 105.0], [-5.0, 105.0], [-6.0, 105.0]
  ],

  // PHILIPPINES
  philippines: [
    [5.0, 120.0], [7.0, 122.0], [9.0, 124.0], [11.0, 125.0], [13.0, 124.0],
    [15.0, 122.0], [17.0, 121.0], [19.0, 121.0], [20.0, 122.0], [18.5, 122.5],
    [16.0, 120.0], [14.0, 120.0], [12.0, 121.0], [10.0, 119.0], [8.0, 117.0],
    [6.0, 118.0], [5.0, 120.0]
  ]
};

export default CONTINENT_COORDS;
